import React from "react";
import { sortBy, uniq } from "lodash";
import { Select, Button } from "react-onsenui";
import {
  getReagent,
  getColors,
  NO_REACTION,
} from "../../services/megamix";
import { isButtonDisabled } from "../../services/megamixUtils";
import ColorButton from "./ColorButton";
import "./QueryEditor.css";

const style = {
  container: {
    maxWidth: "600px",
    margin: "0 auto",
    marginTop: "-20px"
  },
  selectReagent: {
    // marginTop: "0px",
    backgroundColor: "#fff",
    margin: "10px 10px",
    padding: "0 20px",
    borderRadius: "5px",
    boxShadow: "none",
    border: "1px solid lightgrey"
  },
  colorContainer: {
    maxWidth: "400px",
    maxHeight: "210px",
    margin: "10px auto 40px auto",
    display: "grid",
    justifyItems: "center",
    rowGap: "10px",
    gridTemplateColumns: "1fr 1fr 1fr",
    gridTemplateAreas: `
    "black2 brown2 green2"
    "red2 orange2 yellow2"
    "blue2 purple2 pink2"
    "NO_REACTION NO_REACTION NO_REACTION"`
  }
};

export default class QueryEditor extends React.Component {
  // Reagent changed
  handleReagentChange(reagentId) {
    let newQuery = this.props.query || {};
    newQuery.reagentId = parseInt(reagentId);
    this.props.onQueryChange(newQuery);
}

  // Reagent's colors list changed
  handleColorToggle(colorId) {
    const query = this.props.query;
    let newQuery = this.props.query;

    if (query.colorIds === NO_REACTION) newQuery.colorIds = [colorId];
    else if (query.colorIds.includes(colorId))
      newQuery.colorIds = query.colorIds.filter(id => id !== colorId);
    else newQuery.colorIds = query.colorIds.concat([colorId]);

    this.props.onQueryChange(newQuery);
  }

  handleNoReactionToggle = () => {
    const { query } = this.props;
    let newQuery = { ...query };

    if (query.colorIds === NO_REACTION) {
      newQuery.colorIds = [];
    } else {
      newQuery.colorIds = NO_REACTION;
    }
    this.props.onQueryChange(newQuery);
  };

  isColorSelected(colorId) {
    const { query } = this.props;
    if (Array.isArray(query.colorIds)) return query.colorIds.includes(colorId);
    return false;
  }

  isNoReactionSelected() {
    return this.props.query.colorIds === NO_REACTION;
  }

  renderReagents() {
    const { query, availableReagentIds } = this.props;
    let selectableReagentIds = availableReagentIds;
    if (
      query.reagentId != null &&
      !selectableReagentIds.includes(query.reagentId)
    ) {
      selectableReagentIds.push(query.reagentId);
    }
    return sortBy(selectableReagentIds, i => i).map(reagentId => {
      const reagent = getReagent(reagentId);
      return (
        <option key={reagent.id} value={"" + reagent.id}>
          {reagent.fullName}
        </option>
      );
    });
  }

  handleDeleteButtonClicked() {
    this.props.onClose();
    this.props.onQueryChange(null);
  }

  renderColors(colors) {
    const { query, queries, currentSubstanceIds } = this.props;

    return colors.map(color => (
      <ColorButton
        key={color.id}
        hex={color.hex}

        colorId={color.id}
        query={query}
        queries={queries}
        currentSubstanceIds={currentSubstanceIds}

        isSelected={this.isColorSelected(color.id)}
        onColorButtonPress={() => this.handleColorToggle(color.id)}
        colorName={color.name}
        label={color.name}
      />
    ));
  }

  handleInfoClick = () => {
    alert('Find substances by searching for observed reagent test results. Reagent tests are simple chemicals that change color depending on what substance they touch. For best results use multiple reagents. Remember, resuls vary a little due to sample size, reagent condition, light etc.');
  };
  
  renderNoReaction = () => {
    return (
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 20, paddingLeft: '5px'}}>
        <Button
          onClick={() => this.handleNoReactionToggle()}
          style={{ width: 80 }}
          className="no-reaction-button"
        >
          BLANK
        </Button>
        <i
          className="zmdi zmdi-info-outline"
          style={{ cursor: 'pointer' }}
          onClick={this.handleInfoClick} // Function to show alert
        ></i>
      </div>
    );
  };
  

render() {
  const { query, onClose } = this.props;
  const colors = getColors({ simple: true });
  return (
    <div style={style.container} id="queryEditor">
      <div>
        <p style={{textAlign: "center" }}>
          <Select
            name="reagent"
            value={"" + query.reagentId}
            onChange={event => this.handleReagentChange(event.target.value)}
            style={style.selectReagent}
          >
            {this.renderReagents()}
          </Select>
        </p>
      </div>

      <div>
        Select reaction or {this.renderNoReaction()}
        <div style={style.colorContainer} className="colorsContainer">
          {this.renderColors(colors)}
        </div>
      </div>

      {/* <div>
        <Button modifier="large secondary" onClick={onClose.bind(this)} className="testdrugs-queryeditor-accept-button">
          Ok
        </Button>

        <Button
          modifier="large secondary"
          onClick={this.handleDeleteButtonClicked.bind(this)}
          className="testdrugs-queryeditor-delete-button"
        >
          Delete
        </Button>
      </div> */}
    </div>
  );
}


}
